import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Card, CardHeader, CardBody } from 'reactstrap';
import api from '../services/api';
import Layout from '../components/Layout';

const TimeframeManagement = () => {
    const [timeframes, setTimeframes] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [editData, setEditData] = useState({});
    const [newTimeframe, setNewTimeframe] = useState({
        name: '',
        month_start: '',
        day_start: '',
        month_end: '',
        day_end: ''
    });

    useEffect(() => {
        fetchTimeframes();
    }, []);

    const fetchTimeframes = async () => {
        try {
            const response = await api.get('/timeframes/');
            setTimeframes(response.data);
        } catch (error) {
            console.error('Error fetching timeframes:', error);
        }
    };

    const startEdit = (timeframe) => {
        setEditingId(timeframe.id);
        setEditData({ ...timeframe });
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditData({});
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData(prev => ({ ...prev, [name]: value }));
    };

    const saveEdit = async () => {
        try {
            await api.put(`/timeframes/${editingId}/`, editData);
            fetchTimeframes();
            cancelEdit();
        } catch (error) {
            console.error('Error saving timeframe:', error);
        }
    };

    const deleteTimeframe = async (id) => {
        try {
            await api.delete(`/timeframes/${id}/`);
            fetchTimeframes();
        } catch (error) {
            console.error('Error deleting timeframe:', error);
        }
    };

    const handleNewChange = (e) => {
        const { name, value } = e.target;
        setNewTimeframe(prev => ({ ...prev, [name]: value }));
    };

    const addTimeframe = async () => {
        try {
            await api.post('/timeframes/', newTimeframe);
            setNewTimeframe({ name: '', month_start: '', day_start: '', month_end: '', day_end: '' });
            fetchTimeframes();
        } catch (error) {
            console.error('Error adding timeframe:', error);
        }
    };

    return (
        <Layout>
            <Card>
                <CardHeader tag="h3">Organization Timeframes</CardHeader>
                <CardBody>
                    <Table striped hover>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {timeframes.map(timeframe => (
                                <tr key={timeframe.id}>
                                    {editingId === timeframe.id ? (
                                        <>
                                            <td><Input name="name" value={editData.name} onChange={handleEditChange} /></td>
                                            <td>
                                                <Input name="month_start" value={editData.month_start} onChange={handleEditChange} placeholder="MM" />
                                                <Input name="day_start" value={editData.day_start} onChange={handleEditChange} placeholder="DD" />
                                            </td>
                                            <td>
                                                <Input name="month_end" value={editData.month_end} onChange={handleEditChange} placeholder="MM" />
                                                <Input name="day_end" value={editData.day_end} onChange={handleEditChange} placeholder="DD" />
                                            </td>
                                            <td>
                                                <Button color="success" onClick={saveEdit}>Save</Button>{' '}
                                                <Button color="secondary" onClick={cancelEdit}>Cancel</Button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td>{timeframe.name}</td>
                                            <td>{timeframe.month_start}/{timeframe.day_start}</td>
                                            <td>{timeframe.month_end}/{timeframe.day_end}</td>
                                            <td>
                                                <Button color="primary" onClick={() => startEdit(timeframe)}>Edit</Button>{' '}
                                                <Button color="danger" onClick={() => deleteTimeframe(timeframe.id)}>Delete</Button>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                            <tr>
                                <td><Input name="name" value={newTimeframe.name} onChange={handleNewChange} placeholder="Name" /></td>
                                <td>
                                    <Input name="month_start" value={newTimeframe.month_start} onChange={handleNewChange} placeholder="MM" />
                                    <Input name="day_start" value={newTimeframe.day_start} onChange={handleNewChange} placeholder="DD" />
                                </td>
                                <td>
                                    <Input name="month_end" value={newTimeframe.month_end} onChange={handleNewChange} placeholder="MM" />
                                    <Input name="day_end" value={newTimeframe.day_end} onChange={handleNewChange} placeholder="DD" />
                                </td>
                                <td>
                                    <Button color="primary" onClick={addTimeframe}>Add</Button>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        </Layout>
    );
};

export default TimeframeManagement;
